import './MainTabsBodyCuponera.less';

import { KuposButton, KuposModal } from '../../../common';
import React, { useEffect, useState } from 'react';

import { AppData } from '../../../../services';
import DateService from '../../../../services/dateService';
import KuposDataNotFound from '../../../common/KuposDataNotFound';
import getIcons from '../../functions/getIcons/getIcons';

const operator = JSON.parse(localStorage.getItem('op'));

function MainTabsBodyCuponera(props) {
	const [showDetailsModal, setShowDetailsModal] = useState(false);
	const [coupons, setCoupons] = useState([]);
	const [couponInFocus, setCouponInFocus] = useState(null);
	const [listAvailable, setListAvailable] = useState(false);


	//   useEffect(() => {
	//     props.actions.apiCall({
	//       url: AppData.BASE_URL + 'api/services/get_mot_coupons',
	//       type: 'cuponera',
	//       // callback: res => {
	//       //   if (res && res.data && res.data.data) {
	//       //     let cuponsLocal = {};
	//       //     let activeCoupons = 0;
	//       //     Object.keys(res.data.data).forEach(zoneKey => {
	//       //       let zoneData = res.data.data[zoneKey];
	//       //       if (Array.isArray(zoneData)) {
	//       //         Object.keys(zoneData[0]).forEach(cKey => {
	//       //           cuponsLocal[zoneKey + '__' + cKey] = zoneData[0][cKey];
	//       //         });
	//       //       }
	//       //     });
	//       //     setCoupons(cuponsLocal);

	//       //     //to check if there is any active coupon
	//       //     Object.values(cuponsLocal).map(cLocal => {
	//       //       console.log({ cLocal });
	//       //       cLocal.map(coupon => (coupon.status ? activeCoupons++ : null));
	//       //     });

	//       //     console.log({ activeCoupons });

	//       //     if (activeCoupons > 0) {
	//       //       setListAvailable(true);
	//       //     }
	//       //   }
	//       // },

	//       callback: res => {
	//         console.log(res,"===============>>>")
	//         if (res && res.data && res.data.data) {
	//           let couponsLocal = {};
	//           let activeCoupons = 0;
	//           Object.keys(res.data.data).forEach(zoneKey => {
	//             let zoneData = res.data.data[zoneKey];
	//             if (Array.isArray(zoneData)) {
	//               Object.keys(zoneData[0]).forEach(cKey => {
	//                 couponsLocal[zoneKey + "" + cKey] = zoneData[0][cKey];
	//               });
	//             }
	//           });
	//           setCoupons(couponsLocal);

	//           Object.values(couponsLocal).map(cLocal => {
	//             cLocal.map(coupon => (coupon.status ? activeCoupons++ : null));
	//           });

	//           if (activeCoupons > 0) {
	//             setListAvailable(true);
	//           }
	//         }
	//       },
	//     });
	//   }, []);

	useEffect(() => {
		props.actions.apiCall({
			url: AppData.BASE_URL + 'api/services/get_mot_coupons',
			type: "cuponera",
			callback: res => {
				if (res && res.data && res.data.data) {
					let cuponsLocal = {};
					let activeCoupons = 0;
					Object.keys(res.data.data).forEach(zoneKey => {
						let zoneData = res.data.data[zoneKey];
						if (Array.isArray(zoneData)) {
							Object.keys(zoneData[0]).forEach(cKey => {
								cuponsLocal[zoneKey + "__" + cKey] = zoneData[0][cKey];
							});
						}
					});
					setCoupons(cuponsLocal);
					Object.values(cuponsLocal).map(cLocal => {
						console.log({ cLocal });
						cLocal.map(coupon => (coupon.status ? activeCoupons++ : null));
					});

					if (activeCoupons > 0) {
						setListAvailable(true);
					}
				}
			},
		});
	}, []);
	const { t } = props;

	return (
		<div className="sub-section-description scroll-style ">
			<div className="recharge-wallet-top-strip">
				<div className="back-button-format-my-account"></div>
				<div>
					<div className="sub-section-description-title font13">{t('PROFILE.CUPONERA')} </div>
				</div>
				<div></div>
			</div>

			{coupons && listAvailable ? (
				<div className="cuponera_parent">
					{Object.keys(coupons).map(couponKey => {
						const couponGroup = coupons[couponKey];
						let activeCoupons = couponGroup.filter(cp => cp.status);
						let coupon = activeCoupons.length ? activeCoupons[0] : couponGroup[0];
						return activeCoupons.length > 0 ? (
							<div className="coupon_item_outer font11 ">


								{operator && operator.operator_name === "tacoha" ?
									(<div className="cupon_item kupos-card tachoha-icon-size new-font-size ">

										<div className="cupon_title text-center">
											Mi <span className="bold-text">Cuponera</span>
										</div>

										<div className="ticket_items_outer">
											<div className="ticket_items font9">
												{`${activeCoupons.length} / ${couponGroup.length} pasajes`}
											</div>
										</div>

										<div className="qr_container">
											<img
												src={coupon && coupon.qr_code_img ? coupon.qr_code_img : '/svgs/qr.png'}
												alt=""
											/>
										</div>

										<div className="cupon_cod text-center font8">COD : {coupon.coupon_code}</div>

										<div className="operator_name">
											Empresa : <span className="bold-text">{coupon.travel_name}</span>
										</div>

										<div className="operator_name">
											Fecha de compra :{' '}
											{DateService.changeDateFormat(coupon.booked_date, 'yyyy-mm-dd', 'dd-mm-yyyy')}
										</div>

										<div className="location_item">
											<img src={getIcons('Origin', operator)} alt="" /> {coupon.origin}
										</div>
										<div className="location_item">
											<img src={getIcons('Destination', operator)} alt="" /> {coupon.destination}
										</div>

										<div
											className="info_icon"
											onClick={() => {
												setShowDetailsModal(true);
												setCouponInFocus(coupon);
											}}
										>
											<img src="/images/info.svg" alt="info" />
										</div>

									</div>) : (<div className="cupon_item kupos-card">

										<div className="cupon_title text-center">
											Mi <span className="bold-text">Cuponera</span>
										</div>

										<div className="ticket_items_outer">
											<div className="ticket_items font9">
												{`${activeCoupons.length} / ${couponGroup.length} pasajes`}
											</div>
										</div>

										<div className="qr_container">
											<img
												src={coupon && coupon.qr_code_img ? coupon.qr_code_img : '/svgs/qr.png'}
												alt=""
											/>
										</div>

										<div className="cupon_cod text-center font8">COD : {coupon.coupon_code}</div>

										<div className="operator_name">
											Empresa : <span className="bold-text">{coupon.travel_name}</span>
										</div>

										<div className="operator_name">
											Fecha de compra :{' '}
											{DateService.changeDateFormat(coupon.booked_date, 'yyyy-mm-dd', 'dd-mm-yyyy')}
										</div>

										<div className="location_item">
											<img src={getIcons('Origin', operator)} alt="" /> {coupon.origin}
										</div>
										<div className="location_item">
											<img src={getIcons('Destination', operator)} alt="" /> {coupon.destination}
										</div>

										<div
											className="info_icon"
											onClick={() => {
												setShowDetailsModal(true);
												setCouponInFocus(coupon);
											}}
										>
											<img src="/images/info.svg" alt="info" />
										</div>

									</div>)
								}
								{/* <div
                  className="download_strip text-center"
                  onClick={() => window.open(coupon.download_url, '_blank')}
                >
                  <span className="text-center font10">{props.t('PROFILE.DOWNLOAD_COUPON')}</span>
                </div> */}
							</div>
						) : null;
					})}
				</div>
			) : null}

			{(coupons && coupons.length === 0) || !listAvailable ? (
				<KuposDataNotFound
					icon="/images/circular/no-transaction.png"
					title={props.t('PROFILE.NO_COUPONS')}
					subTitle={props.t('PROFILE.PURCHASE_YOUR_COUPONS')}
					infoText={props.t('PROFILE.PURCHASE_COUPONS_HERE')}
					onInfoClick={() => props.history.push('/')}
				/>
			) : null}

			<KuposModal
				showModal={showDetailsModal}
				onHide={() => setShowDetailsModal(false)}
				size="sm"
				ariaLabel="login-modal"
			>
				<div className="bip-info-modal-container cuponera_modal font11">
					{operator && operator.operator_name === 'tacoha' ?
						(<div className="img_container">
							<img src="/assets/tacoha/searchbar/acc.svg" alt="info" />
						</div>) : (<div className="img_container">
							<img src="/images/warning.png" alt="info" />
						</div>)
					}


					<div className="title center-text bold-text font15">
						<span className="font14">¡información importante!</span>
					</div>

					<div className="desc font11">
						La cuponera seleccionada puede ser utilizada en los siguientes origenes y destinos:
					</div>

					<div className="locations text-center font11">
						<div className="location">
							•{' '}
							<span className="bold-text">
								{couponInFocus && couponInFocus.zone_routes && couponInFocus.zone_routes[0].origin}
							</span>{' '}
							a{' '}
							<span className="bold-text">
								{couponInFocus &&
									couponInFocus.zone_routes &&
									couponInFocus.zone_routes[0].destination}
							</span>{' '}
							y viceversa.
						</div>
						{/* <div className="location">• Santiago a Valparaíso y viceversa.</div> */}
						{/* <div className="location">• Santiago a Villa Alemana y viceversa.</div> */}
					</div>

					<div className="btn_container">
						<KuposButton onClick={() => setShowDetailsModal(false)} className="modal_btn">
							{props.t('PROFILE.ACCEPT_BUTTON')}
						</KuposButton>
					</div>
				</div>
			</KuposModal>
		</div>
	);
}

export default MainTabsBodyCuponera;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/MainTabsBodyCuponera/MainTabsBodyCuponera.js